import styled from '@emotion/styled';

const SimpleGrid = styled.div(() => {
  return `
    display: grid;
    grid-gap: 0 var(--spacing-sm);
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  `;
});

export default SimpleGrid;
